import { render } from "./blog-quote-image.vue?vue&type=template&id=ca4232ac&scoped=true"
import script from "./blog-quote-image.vue?vue&type=script&lang=js"
export * from "./blog-quote-image.vue?vue&type=script&lang=js"

import "./blog-quote-image.vue?vue&type=style&index=0&id=ca4232ac&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4232ac"]])

export default __exports__